import { NotificationsView } from '../app/components/NotificationsView';

/**
 * NotificationsPage
 *
 * Simple wrapper for notifications view.
 * No modals or query parameters needed for now.
 */
export function NotificationsPage() {
  return <NotificationsView />;
}
